import { render, staticRenderFns } from "./DeviceYearPowerSaveChart.vue?vue&type=template&id=323e83f2&scoped=true"
import script from "./DeviceYearPowerSaveChart.vue?vue&type=script&lang=js"
export * from "./DeviceYearPowerSaveChart.vue?vue&type=script&lang=js"
import style0 from "./DeviceYearPowerSaveChart.vue?vue&type=style&index=0&id=323e83f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323e83f2",
  null
  
)

export default component.exports